import ShopHomeLayout from "@/layouts/ShopHomeLayout.vue";
import iousRouter from "@/config/iousServices";
import shouyinRouter from "@/config/shouyin";
import marketActivityRouter from '@/config/marketActivity'

/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  industryMall.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2023/1/3 9:57
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/* 产业圈模块 */
const industryMallRouter = [
  {
    path: "/shopHome",
    name: "ShopHome",
    component: () =>
      import(
        /* webpackChunkName: "industryMall" */ "@/views/homes/industryMall.vue"
      ),
    meta: {
      title: "产业圈",
      keepAlive: true,
      deepth: 1,
    },
  },
  {
    path: "/shopHomeLayout",
    component: ShopHomeLayout,
    hidden: true,
    redirect: "/mall",
    meta: {
      keepAlive: false,
      deepth: 1,
    },
    children: [
      {
        path: "/mall",
        name: "Mall",
        component: () =>
          import(
            /* webpackChunkName: "mall" */ "@/views/industryMall/shop/NewIndex.vue"
          ),
        meta: {
          title: "采购商城",
          keepAlive: true,
          deepth: 2,
        },
      },
      {
        path: "/mallCategory",
        name: "MallCategory",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/mallCategory/index.vue"
          ),
        meta: {
          title: "商品分类",
          keepAlive: true,
          deepth: 2,
        },
      },
      {
        path: "/buyMallCar",
        name: "buyMallCar",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/buyCar/Index.vue"
          ),
        meta: {
          title: "购物车",
          keepAlive: true,
          deepth: 2,
        },
      },
      {
        path: "/shopMallOrder",
        name: "ShopMallOrder",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/Index.vue"
          ),
        meta: {
          title: "工作台",
          // keepAlive: true,
          permission: true,
          deepth: 2,
        },
      },
      {
        path: "/goods",
        name: "Goods",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/goods/index.vue"
          ),
        meta: {
          title: "商品",
          keepAlive: true,
          permission: true,
          deepth: 2,
        },
      },
      {
        path: "/goodDetail",
        name: "goodDetail",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/goods/goodDetail.vue"
          ),
        meta: {
          title: "商品详情",
          // keepAlive: true,
          permission: true,
          deepth: 3,
        },
      },
      {
        path: "/shelf",
        name: "Shelf",
        component: () =>
          import(/* webpackChunkName: "goods" */ "@/views/shelf/MyShelf.vue"),
        meta: {
          title: "次日达管理",
          // keepAlive: true,
          permission: true,
          deepth: 2,
        },
      },
      {
        path: "/salesSlip",
        name: "salesSlip",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/orderManage/SalesOrder/SalesSilp.vue"
          ),
        meta: {
          title: "次日达订单",
          // keepAlive: true,
          permission: true,
          deepth: 2,
        },
      },
      {
        path: "/salespromotion",
        name: "salespromotion",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/orderManage/sales/SalesPromotion.vue"
          ),
        meta: {
          title: "促销活动",
          // keepAlive: true,
          permission: true,
          deepth: 2,
        },
      },
      {
        path: "/salesstatistics",
        name: "salesstatistics",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/orderManage/sales/SalesStatistics.vue"
          ),
        meta: {
          title: "销售统计",
          // keepAlive: true,
          permission: true,
          deepth: 2,
        },
      },
      // {
      //   path: '/mallCategory',
      //   name: 'mallCategory',
      //   component: () =>
      //           import(/* webpackChunkName: "industryMall" */ '@/views/industryMall/mallCategory/Index.vue'),
      //   meta: {
      //     title: '分类',
      //     // keepAlive: true,
      //     deepth: 2
      //   },
      // },
      {
        path: "/goodsMallDetail",
        name: "GoodsMallDetail",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/GoodsDetail.vue"
          ),
        meta: {
          title: "商品详情",
          keepAlive: true,
          deepth: 5,
        },
      },
      {
        path: "/shopMallInfo",
        name: "ShopMallInfo",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/ShopMallInfo.vue"
          ),
        meta: {
          title: "",
          keepAlive: true,
          deepth: 5,
        },
      },
      {
        path: "/activity",
        name: "Activity",
        component: () =>
          import(
            /* webpackChunkName: "shopMallInfo" */ "@/views/industryMall/shop/Activity.vue"
          ),
        meta: {
          title: "",
          keepAlive: true,
          deepth: 3,
        },
      },
      {
        path: "/submitMallOrder",
        name: "SubmitMallOrder",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/buyCar/NewSubmitOrder.vue"
          ),
        meta: {
          title: "提交订单",
          keepAlive: true,
          deepth: 7,
        },
      },
      {
        path: "/orderMall",
        name: "OrderMall",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/OrderMall.vue"
          ),
        meta: {
          title: "全部订单",
          keepAlive: true,
          deepth: 3,
        },
      },
      {
        path: "/orderMallDetail",
        name: "OrderMallDetail",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/OrderMallDetail.vue"
          ),
        meta: {
          title: "订单详情",
          keepAlive: false,
          deepth: 4,
        },
      },
      {
        path: "/discountSale",
        name: "HotSale",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/DiscountSale.vue"
          ),
        meta: {
          title: "限时折扣",
          keepAlive: true,
          deepth: 5,
        },
      },
      {
        path: "/mallSubmitSuccess",
        name: "mallSubmitSuccess",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/buyCar/SubmitSuccess.vue"
          ),
        meta: {
          title: "订单提交成功",
          keepAlive: false,
          deepth: 5,
        },
      },
      {
        path: "/mallLog",
        name: "mallLog",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/Log.vue"
          ),
        meta: {
          title: "订单日志",
          keepAlive: false,
          deepth: 5,
        },
      },
      {
        path: "/mallChoosePackage",
        name: "mallChoosePackage",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/returnOrder/ChoosePackage.vue"
          ),
        meta: {
          title: "选择退货商品",
          keepAlive: false,
          deepth: 5,
        },
      },
      {
        path: "/mallSubmitReturnOrder",
        name: "mallSubmitReturnOrder",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/returnOrder/SubmitReturnOrder.vue"
          ),
        meta: {
          title: "提交退单",
          keepAlive: false,
          deepth: 5,
        },
      },
      {
        path: "/mallReturnOrderDetail",
        name: "MallReturnOrderDetail",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/returnOrder/MallReturnOrderDetail.vue"
          ),
        meta: {
          title: "退单详情",
          keepAlive: false,
          deepth: 5,
        },
      },
      {
        path: "/MallSubmitReturnSuccess",
        name: "MallSubmitReturnSuccess",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/order/returnOrder/SubmitReturnSuccess.vue"
          ),
        meta: {
          title: "退单提交成功",
          keepAlive: false,
          deepth: 5,
        },
      },
      {
        path: "/MallSearchHistory",
        name: "MallSearchHistory",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/SearchHistory.vue"
          ),
        meta: {
          title: "搜索",
          keepAlive: true,
          deepth: 3,
        },
      },
      {
        path: "/SearchLimitActivity",
        name: "SearchLimitActivity",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/SearchLimitActivity.vue"
          ),
        meta: {
          title: "搜索",
          keepAlive: true,
          deepth: 4,
        },
      },
      {
        path: "/ShopSearchHistory",
        name: "ShopSearchHistory",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/ShopSearchHistory.vue"
          ),
        meta: {
          title: "搜索",
          keepAlive: true,
          deepth: 3,
        },
      },
      {
        path: "/MallSearchShop",
        name: "MallSearchShop",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/SearchShop.vue"
          ),
        meta: {
          title: "搜索",
          keepAlive: true,
          deepth: 4,
        },
      },
      {
        path: "/MallSearchGoods",
        name: "MallSearchGoods",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/shop/SearchGoods.vue"
          ),
        meta: {
          title: "搜索",
          keepAlive: true,
          deepth: 4,
        },
      },
      {
        path: "/SearchCategoryGoods",
        name: "SearchCategoryGoods",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/mallCategory/SearchCategoryGoods.vue"
          ),
        meta: {
          title: "搜索",
          keepAlive: true,
          deepth: 4,
        },
      },
      {
        path: "/storeCollectList",
        name: "storeCollectList",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/storeCollectList/storeCollectList.vue"
          ),
        meta: {
          title: "店铺列表",
          keepAlive: false,
          deepth: 4,
        },
      },
      {
        path: "/differentialPricing",
        name: "DifferentialPricing",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/goods/differentialPricing.vue"
          ),
        meta: {
          title: "差异定价",
          keepAlive: true,
          deepth: 5,
        },
      },
      {
        path: "/addGoods",
        name: "AddGoods",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/addGoods/index.vue"
          ),
        meta: {
          title: "新增商品",
          // keepAlive: true,
          deepth: 3,
        },
      },
      {
        path: "/addGoodsAssociate",
        name: "addGoodsAssociate",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/addGoods/addGoodsAssociate.vue"
          ),
        meta: {
          title: "新增商品",
          keepAlive: false,
          deepth: 2,
        },
      },
      {
        path: "/goodsManage",
        name: "GoodsManage",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/goodsManage/index.vue"
          ),
        meta: {
          title: "商品管理",
          keepAlive: true,
          deepth: 2,
        },
      },
      {
        path: "/storeOrderManage",
        name: "storeOrderManage",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/orderManage/index.vue"
          ),
        meta: {
          title: "订单管理",
          keepAlive: false,
          deepth: 2,
        },
      },
      {
        path: "/mendianOrderlDetail",
        name: "MendianOrderlDetail",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/orderManage/mendianOrderlDetail.vue"
          ),
        meta: {
          title: "订单详情",
          keepAlive: false,
          deepth: 3,
        },
      },
      {
        path: "/weidianOrderDetail",
        name: "WeidianOrderDetail",
        component: () =>
          import(
            /* webpackChunkName: "industryMall" */ "@/views/industryMall/orderManage/weidianOrderDetail.vue"
          ),
        meta: {
          title: "微店订单详情",
          keepAlive: false,
          deepth: 3,
        },
      },
      {
        path: "/weidianGoodsManage",
        name: "WeidianGoodsManage",
        component: () =>
          import(
            /* webpackChunkName: "goods" */ "@/views/industryMall/weidianGoodsManage/index.vue"
          ),
        meta: {
          title: "商品管理",
          keepAlive: true,
          deepth: 2,
        },
      },
      ...iousRouter,
      ...shouyinRouter,
      ...marketActivityRouter
    ],
  },
];

export default industryMallRouter;
